import { FC, useEffect, useState } from 'react';
import { CustomOption, CustomOptionWrapper, SelectingItemMainWrapper, SettingPanelMultiSelectItem } from '../../../Player/styles';
import { PlayBackRateProps, PlaySpeed, settingControllerKey } from '../../../Player/PlayerModels';
import {  IconSpeedRate } from '../../../../icons';
import { PanelSettingHeader, PanelSettingLayer } from '../../../Player/styles/Panel';
import { Box } from '../../../../styles';

export const PlaybackRateSelector: FC<{ player: HTMLVideoElement,  handleSettingItemClick: (controllerKey: settingControllerKey) => void, activeSetting: string | null}> = ({ player, handleSettingItemClick, activeSetting }) => {
  const [selectedRate, setSelectedRate] = useState<number>(player.playbackRate || 1);
  const [isOpen, setIsOpen] = useState(false);
  const rates = [
    { label: '0/5', value: 0.5 },
    { label: '0/75', value: 0.75 },
    { label: '1' + ' (عادی)', value: 1 },
    { label: '1/25', value: 1.25 },
    { label: '1/5', value: 1.5 },
    { label: '2', value: 2 },
  ];

  useEffect(() => {
    const onRateChange = () => setSelectedRate(player.playbackRate || 1);
    player.addEventListener('ratechange', onRateChange);
    return () => player.removeEventListener('ratechange', onRateChange);
  }, [player]);

  const changePlaybackRate = (speed: number) => {
    setSelectedRate(speed);
    if (player) {
      player.playbackRate = speed;
      setIsOpen(false);
    }
  };
  const toggleMenu = (e, key) => {
    e.stopPropagation();
    handleSettingItemClick(key);
    setIsOpen(!isOpen);
  };

  return <>
    {/* eslint-disable-next-line eqeqeq */}
    {!activeSetting && <SettingPanelMultiSelectItem icon={<IconSpeedRate />} label="player.speed_rate" onClick={(e) => toggleMenu(e, 'speed')} value={ selectedRate == 1 ?  '1' + ' (عادی)' : String(selectedRate).replace('.', '/')} />}
    {activeSetting === 'speed' && <PanelSettingLayer>
      <RateSelect value={selectedRate || ''} options={rates} onChange={changePlaybackRate}  returnAction={(e) => toggleMenu(e, null)}/>
    </PanelSettingLayer>}
  </>;
};

export default PlaybackRateSelector;

const RateSelect = ({ value, options, onChange, returnAction }: PlayBackRateProps) => {
  return (
    <Box>
      <PanelSettingHeader label={'player.speed_rate'} handleClick={(e) => returnAction(e)} />
      <SelectingItemMainWrapper>{options.map((item: PlaySpeed) => (
        <CustomOptionWrapper key={item.value} onClick={(e: any) => {
          onChange(String(item.value));
          returnAction(e);
        }}>
          <CustomOption  selected={String(item.value) === String(value)} >
            {item.label}
          </CustomOption>
        </CustomOptionWrapper>
      ))}
      </SelectingItemMainWrapper>
    </Box>
  );
};
